<nb-card
	class="jobs-page card-scroll"
	[nbSpinner]="loading"
	nbSpinnerStatus="primary"
	nbSpinnerSize="large"
>
	<nb-card-header class="header">
		<h4> <ngx-header-title [allowEmployee]="false"> {{ 'JOB_EMPLOYEE.EMPLOYEES' | translate }} </ngx-header-title> </h4>
	</nb-card-header>
	<nb-card-body>
		<ng2-smart-table
			[settings]="settingsSmartTable"
			[source]="smartTableSource"
			#jobEmployeesTable
		></ng2-smart-table>
	</nb-card-body>
</nb-card>
